import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useErrorNotification } from "@common/components/Notification";
import Grid from "@mui/material/Grid2";
import { ConsultedRooms, CustomRoom } from "@services/meetings/types";
import React from "react";
import { useTranslation } from "react-i18next";
import { AddParticipantContext } from "../..";
import RoomCard from "../../RoomCard";

type RecentTabProps = {
  search: string;
  excludeExternal: boolean;
};

const RecentTab = (props: RecentTabProps) => {
  const { search, excludeExternal } = props;
  const { recents, selectedRooms } = React.useContext(AddParticipantContext);
  const context = React.useContext(RoomsRealtimeContext);
  const dispatchError = useErrorNotification();
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="column"
      sx={{ width: '100%', gap: "1rem", }}
    >
      {recents.internal
        .filter(
          (room) =>
            room.name?.toLowerCase().includes(search) &&
            (!excludeExternal || (excludeExternal && room.managed)) &&
            !selectedRooms.some((r) => r.id === room.id) &&
            !context.detail?.meeting?.participants?.some(
              (participant) => participant.room?.id === room.id
            )
        )
        .sort((a, b) => ((a.name ?? "") > (b.name ?? "") ? 1 : -1))
        .map((recent) => (
          <RoomCard key={recent.id} room={recent} />
        ))}
      {!excludeExternal &&
        recents.external
          .filter(
            (room) =>
              room.name?.toLowerCase().includes(search) &&
              !(selectedRooms as CustomRoom[]).some(
                (r) => r.name === room.name && r.address === room.address
              ) &&
              !context.detail?.meeting?.participants?.some(
                (participant) => participant.room?.id === room.id
              )
          )
          .sort((a, b) => ((a.name ?? "") > (b.name ?? "") ? 1 : -1))
          .map((recent) => <RoomCard key={recent.id} customRoom={recent} />)}
    </Grid>
  );
};

export default RecentTab;
